var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Kotlin",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.266,
    y1: -1.426,
    x2: 0.738,
    y2: -0.484,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.097,
    stopColor: "#0095d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301,
    stopColor: "#238ad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#557bde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#7472e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#806ee3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.14,
    y1: 1.506,
    x2: 0.687,
    y2: 2.012,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#0095d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#3c83dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#6d74e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#806ee3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.168,
    y1: 0.097,
    x2: 0.762,
    y2: 1.028,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#c757bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#d0609a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#e1725c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#ee7e2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#f58613"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#f88909"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M0,45.953,16.053,29.9,32,45.953Z",
    transform: "translate(0 -13.953)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M0,0H16.053L0,17.333Z",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M16.053,0,0,16.907V32L16.053,15.947,32,0Z",
    fill: "url(#linear-gradient-3)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/Kotlin.742863da20812fd77d4d20b959e0b998.svg";
export { ForwardRef as ReactComponent };